import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";
import { findIndex } from "lodash";

const mutations = {
  
  //fetch all exemption
  [types.GET_EXEMPTIONS_BEGIN](state) {
    state.exemptionsGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_EXEMPTIONS_SUCCESS](state, exemptions) {
    state.exemptionsGetError = null;
    state.exemptions = exemptions;
    state.exemptionsGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_EXEMPTIONS_ERROR](state, err) {
    state.exemptionsGetState = API_STATES.REQUEST_ERROR;
    state.exemptionsGetError = err;
  },

  //delete exemption
  [types.DELETE_EXEMPTION_BEGIN](state) {
    state.exemptionDeleteState = API_STATES.REQUEST_PENDING;
  },
  [types.DELETE_EXEMPTION_SUCCESS](state) {
    state.exemptionDeleteError = null;
    state.exemptionDeleteState = API_STATES.REQUEST_SUCCESS;
  },
  [types.DELETE_EXEMPTION_ERROR](state, err) {
    state.exemptionDeleteState = API_STATES.REQUEST_ERROR;
    state.exemptionDeleteError = err;
  },

  //create exemption
  [types.CREATE_EXEMPTION_BEGIN](state) {
    state.exemptionCreateState = API_STATES.REQUEST_PENDING
  },
  [types.CREATE_EXEMPTION_SUCCESS](state, data) {
    state.exemptionCreateError = null
    state.exemptionCreateState = API_STATES.REQUEST_SUCCESS
    state.exemption = data
  },
  [types.CREATE_EXEMPTION_ERROR](state, err) {
    state.exemptionCreateState = API_STATES.REQUEST_ERROR;
    state.exemptionCreateError = err;
  },

  //updata exemption settings
  [types.UPDATE_EXEMPTION_BEGIN](state) {
    state.exemptionUpdateState =  API_STATES.REQUEST_PENDING
  },
  [types.UPDATE_EXEMPTION_SUCCESS](state, data) {
    state.exemptionUpdateError = null
    state.exemption = data
    state.exemptionUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.UPDATE_EXEMPTION_ERROR](state, err) {
    state.exemptionUpdateState = API_STATES.REQUEST_ERROR
    state.exemptionUpdateError = err
  },
  
  //assign exemption to particular user
  [types.ADD_USER_EXEMPTION_BEGIN](state,userId) {
    state.userExemptionUpdating.push(userId)
  },
  [types.ADD_USER_EXEMPTION_SUCCESS](state, { data, rootState }) {
    const index = findIndex(state.userExemptionUpdating, data.userId);
    state.userExemptionUpdating.splice(index, 1);

    rootState.app.formData.userExemptions.push(data)
    state.userExemptionUpdateError = null
  },
  [types.ADD_USER_EXEMPTION_ERROR](state, { err,userId }) {
    const index = findIndex(state.userExemptionUpdating, userId);
    state.userExemptionUpdating.splice(index, 1);
    state.userExemptionUpdateError = err;
  },

  //un-assign exemption to particular user
  [types.DELETE_USER_EXEMPTION_BEGIN](state, userId) {
    state.userExemptionDeleting.push(userId);
  },
  [types.DELETE_USER_EXEMPTION_SUCCESS](state, { userId, rootState }) {
    const index = findIndex(rootState.app.formData.userExemptions, { userId });
    rootState.app.formData.userExemptions.splice(index, 1)
    
    const index2 = findIndex(state.userExemptionDeleting, userId);
    state.userExemptionDeleting.splice(index2, 1);
    
    state.userExemptionDeleteError = null;
  },
  [types.DELETE_USER_EXEMPTION_ERROR](state, { err, userId }) {
    const index = findIndex(state.userExemptionDeleting, userId);
    state.userExemptionDeleting.splice(index, 1);
    state.userExemptionDeleteError = err;
  },
  
  //assign task exemption to particular user
  [types.ADD_TASK_EXEMPTION_BEGIN](state, taskId) {
    state.taskExemptionUpdating.push(taskId)
  },
  [types.ADD_TASK_EXEMPTION_SUCCESS](state, { data, rootState }) {
    const index = findIndex(state.taskExemptionUpdating, data.taskId);
    state.taskExemptionUpdating.splice(index, 1);

    rootState.app.formData.taskExemptions.push(data)
    state.userDepartmentUpdateError = null
  },
  [types.ADD_TASK_EXEMPTION_ERROR](state, { err, taskId }) {
    const index = findIndex(state.taskExemptionUpdating, taskId);
    state.taskExemptionUpdating.splice(index, 1);
    state.userDepartmentUpdateError = err;
  },

  //un-assign task exemption to particular user
  [types.DELETE_TASK_EXEMPTION_BEGIN](state, taskId) {
    state.taskExemptionDeleting.push(taskId);
  },
  [types.DELETE_TASK_EXEMPTION_SUCCESS](state, { taskId, rootState }) {
    state.taskExemptionDeleteError = null;
    
    const index = findIndex(rootState.app.formData.taskExemptions, { taskId });
    rootState.app.formData.taskExemptions.splice(index, 1)

    const index2 = findIndex(state.taskExemptionDeleting, taskId );
    state.taskExemptionDeleting.splice(index2, 1);
  },
  [types.DELETE_TASK_EXEMPTION_ERROR](state, { err, taskId }) {
    const index = findIndex(state.taskExemptionDeleting, taskId);
    state.taskExemptionDeleting.splice(index, 1);
    state.taskExemptionDeleteError = err;
  }
};

export default mutations;
